import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin } from 'lucide-react';
const researchers = [{
  name: 'Ginger Dhaliwal',
  title: 'CO-FOUNDER & OPERATOR',
  tags: ['Cofounder', 'Partner, Sero Partners', 'Angel Investor'],
  bio: "Co-founder, operator, and angel investor with over 20 years of experience building and scaling technology companies globally. She advises and invests in early-stage founders as both an angel investor and LP. Having built and exited startups across North America, Europe, and Asia, Ginger brings a practitioner's lens to understanding how founder relationships shape execution, resilience, and long-term outcomes.",
  linkedin: 'https://www.linkedin.com/in/ginger-dhaliwal-6276875b/',
  image: 'https://cdn.magicpatterns.com/uploads/jFcwHWW2i5KEQjKWxRboTM/IMG_3222.jpg'
}, {
  name: 'Alička C. Pistek',
  title: 'RESEARCHER & STRATEGIST',
  tags: ['Co-author, The New Superpower for Women', 'Simon & Schuster / Amazon Bestseller'],
  bio: 'Researcher and communications strategist specializing in narrative, trust, and how ideas move through complex human systems. A former literary agent and ghostwriter, Alička brings deep expertise in storytelling, positioning, and sense-making — skills she now applies to studying founder dynamics, alignment, and decision-making.',
  linkedin: 'https://www.linkedin.com/in/alickacpistek/',
  image: 'https://cdn.magicpatterns.com/uploads/tMWY3DmpGy6WSwh54JQaQn/Facetune_04-08-2025-18-00-42.jpg'
}];
export function ResearchersSection() {
  return <section id="researchers" className="px-4 sm:px-8 md:px-[60px] py-[140px] bg-[#F8FAF9]" data-id="element-1112">
      <div className="max-w-[1400px] mx-auto" data-id="element-1113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-1114">
          <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-8" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 600,
          letterSpacing: '3px',
          lineHeight: 1.0,
          borderRadius: '4px'
        }} data-id="element-1115">
            THE TEAM BEHIND THE RESEARCH
          </div>
          <h2 className="text-[#1A3D3A] mb-6" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 'clamp(40px, 5vw, 56px)',
          fontWeight: 500,
          lineHeight: 1.1,
          letterSpacing: '-1px'
        }} data-id="element-1116">
            Meet the Researchers
          </h2>
          <div className="w-16 h-[1px] bg-[#3D5654] mx-auto mb-8 opacity-30" data-id="element-1117"></div>
          <p className="text-[#3D5654] max-w-3xl mx-auto" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '17px',
          fontWeight: 400,
          lineHeight: 1.8
        }} data-id="element-1118">
            Combining decades of operator experience with deep expertise in
            narrative and human systems to decode what makes co-founder
            relationships thrive.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-[40px] mt-16" data-id="element-1119">
          {researchers.map((researcher, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="bg-white rounded-[16px] p-10" style={{
          boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
        }} data-id="element-1120">
              <div className="flex items-start gap-6 mb-6" data-id="element-1121">
                <img src={researcher.image} alt={researcher.name} className="w-24 h-24 rounded-full object-cover flex-shrink-0" style={{
              boxShadow: '0 4px 20px rgba(26, 61, 58, 0.15)',
              objectPosition: 'center 30%'
            }} data-id="element-1122" />
                <div className="flex-1" data-id="element-1123">
                  <div className="flex items-start justify-between mb-2" data-id="element-1124">
                    <p className="text-[#3D5654]" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '11px',
                  fontWeight: 600,
                  letterSpacing: '1.5px',
                  textTransform: 'uppercase',
                  opacity: 0.7
                }} data-id="element-1125">
                      {researcher.title}
                    </p>
                    {researcher.linkedin && <a href={researcher.linkedin} target="_blank" rel="noopener noreferrer" className="text-[#1A3D3A] hover:opacity-70 transition-opacity" aria-label="LinkedIn Profile" data-id="element-1126">
                        <Linkedin className="w-5 h-5" data-id="element-1127" />
                      </a>}
                  </div>
                  <h3 className="text-[#1A3D3A]" style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '28px',
                fontWeight: 500,
                lineHeight: 1.2
              }} data-id="element-1128">
                    {researcher.name}
                  </h3>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-6" data-id="element-1129">
                {researcher.tags.map((tag, tagIndex) => <span key={tagIndex} className="inline-block px-3 py-1.5 bg-[#F8FAF9] rounded-full border border-[rgba(26,61,58,0.15)]" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '12px',
              fontWeight: 400,
              color: '#3D5654'
            }} data-id="element-1130">
                    {tag}
                  </span>)}
              </div>

              <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1131">
                {researcher.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}